import React, { ComponentPropsWithoutRef } from 'react';
import { TableHead } from '@rbx/ui';
import useMarkdownTableStyles from './MarkdownTable.styles';

type MarkdownTableHeadProps = ComponentPropsWithoutRef<typeof TableHead>;

export default function MarkdownTableHead({ children, ...otherProps }: MarkdownTableHeadProps) {
  const {
    classes: { header },
  } = useMarkdownTableStyles();

  return (
    <TableHead {...otherProps} className={header}>
      {children}
    </TableHead>
  );
}
